<script>
export default {
  name: "topNav"
};
</script>

<template>
  <div>
    <el-row>
      <el-col :span="12">
        <h3>Logo</h3>
        <!--        <img src="../../assets/logo.png"/>-->
      </el-col>
      <el-col :span="12">
        <h3>Icon</h3>
        <!--        <el-button type="primary" :icon="Edit" />-->
      </el-col>
    </el-row>
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/package/topNav.vue